import bbitApi from '@api/make-request'

export function getFile(id) {
  return bbitApi.get(`/files/api/v1/files/${id}`)
}
